export default __webpack_public_path__ + "static/media/vexado.e7ef70e7.ico";